import gql from 'graphql-tag'

const POSTULE = gql`
    mutation  postule($id_offer: ID!){
        postule(id_offer: $id_offer){
            id
        }
    }
`;
export default POSTULE;